import * as Yup from 'yup';

export const getForgotPasswordSchema = () => {
  return Yup.object().shape({
    email: Yup.string()
      .email('Invalid email format')
      .matches(/^[a-zA-Z0-9](.*[a-zA-Z0-9])?$/, 'Invalid email format')
      .required('Email is required'),
  });
};
